import * as React from 'react'
import { Link } from 'react-router-dom'

import { Box, Button, Icon, IconBadge, List, Text } from '@factorialco/deprecated-design-system'
import isNil from 'lodash/isNil'

import { observer } from 'mobx-react'

import { dateToString, stringToDate } from 'modules/core/lib/dates'

import { Notification } from 'modules/job_catalog/hooks/useNotifications'
import { useNotificationMarkAsClicked } from 'modules/notifications/hooks/useNotificationMarkAsClicked'

type Props = {
  notification: Notification
}

const NotificationItem = ({ notification }: Props) => {
  const { markAsClicked } = useNotificationMarkAsClicked()
  const creationDate = dateToString(
    stringToDate(notification.createdAt, 'backend_datetime'),
    'ui_short_with_time'
  )
  const readTime = isNil(notification.readAt)
    ? null
    : stringToDate(notification.readAt, 'backend_datetime')

  const showAsUnread = isNil(readTime)

  const notificationLinkOpened = () => {
    markAsClicked(notification.id)
  }

  const notificationTitle = notification.readAt ? (
    <Text size="200" color="grey800">
      {notification.title}
    </Text>
  ) : (
    <List.Title>{notification.title}</List.Title>
  )

  return (
    <List.Item>
      <Box flexDirection="row" paddingY="s8" gap="s24" alignItems="center" width="full">
        <IconBadge icon="bell" size="s32" />

        <Box minWidth="s0">
          <Text color="grey800" size="200">
            {creationDate}
          </Text>
          {notificationTitle}
          <List.Description>{notification.body}</List.Description>
        </Box>

        <Box flexGrow alignItems="flexEnd">
          <Box flexDirection="row" gap="s12" alignItems="center">
            {showAsUnread && <Icon.Small icon="circle" color="viridian1000" />}
            {notification.webResourceUrl && (
              <Link
                to={notification.webResourceUrl}
                data-testid="url-button"
                onClick={notificationLinkOpened}
              >
                <Button type="secondary" iconName="arrow-right" />
              </Link>
            )}
          </Box>
        </Box>
      </Box>
    </List.Item>
  )
}

export default observer(NotificationItem)
